export const ClientLicenseStatus = {
    ALL_STATUSES: "allStatuses",
    NOT_STARTED: "notStarted",
    ACTIVE: "active",
    TERMINATED: "terminated",
    EXPIRED: "expired",
    INITIAL_PAYMENT_REQUIRED: "initialPaymentRequired",
    INVALID_STATUS: "invalidStatus"
};

export const FormStep = {
    PAGE_PURCHASE_LICENSE: 1,
    PAGE_PAYMENT_CONFIRMATION: 2,
    PAGE_PURCHASE_SUCCESSFUL: 3
};
